import { render, staticRenderFns } from "./EventsCalendarSection.vue?vue&type=template&id=2e062fe4&scoped=true"
import script from "./EventsCalendarSection.vue?vue&type=script&lang=js"
export * from "./EventsCalendarSection.vue?vue&type=script&lang=js"
import style0 from "./EventsCalendarSection.vue?vue&type=style&index=0&id=2e062fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e062fe4",
  null
  
)

export default component.exports